import React from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { Button } from '@material-ui/core';
import { AddIcon } from 'components/icons';
import Table from 'components/widgets/Table';
import Header from 'components/widgets/Header';
import InputSearch from 'components/widgets/InputSearch';

const CustomerPanel = ({
    classes,
    search,
    inHouse,
    showAddNewCustomerButton,
    onClickNewCustomerButton,
    onSearch,
    loadingCustomerInfo,
    records,
    onSelectedRecord,
    getCustomerColumns,
}) => (
    <div className={classes.main}>
        <Header>
            <InputSearch
                autoFocus
                customClasses={clsx(search)}
                onSearch={onSearch}
            />
            {!inHouse && showAddNewCustomerButton && (
                <Button
                    variant="outlined"
                    color="secondary"
                    startIcon={<AddIcon />}
                    size="small"
                    onClick={onClickNewCustomerButton}
                >
                    Add new customer
                </Button>
            )}
        </Header>
        <div className={classes.mainTable}>
            <Table
                rowSelected
                cursor="default"
                load={loadingCustomerInfo}
                totalRecords={records.length || 0}
                data={loadingCustomerInfo ? [] : records}
                columns={getCustomerColumns()}
                enableRowHover
                getTrProps={(_, rowInfo) => ({
                    onDoubleClick: () => {
                        onSelectedRecord(rowInfo.original);
                    },
                    onClick: () => {
                        onSelectedRecord(rowInfo.original);
                    },
                })}
            />
        </div>
    </div>
);
CustomerPanel.propTypes = {
    classes: PropTypes.object.isRequired,
    search: PropTypes.string,
    inHouse: PropTypes.bool.isRequired,
    showAddNewCustomerButton: PropTypes.bool,
    onClickNewCustomerButton: PropTypes.func.isRequired,
    onSearch: PropTypes.func.isRequired,
    loadingCustomerInfo: PropTypes.bool,
    records: PropTypes.array.isRequired,
    onSelectedRecord: PropTypes.func.isRequired,
    getCustomerColumns: PropTypes.func.isRequired,
};

CustomerPanel.defaultProps = {
    search: '',
    showAddNewCustomerButton: false,
    loadingCustomerInfo: false,
};

export default CustomerPanel;
